import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ContextProvider } from "./contexts/ContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter 
  //  basename="wagle/DailyPostingAutomation"
   >
    <ContextProvider>
      <App />
    </ContextProvider>
  </BrowserRouter>
);
